/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdvisorConfiguracaoResponse,
  ConfigurarAdvisorDto,
  ErroResponse,
  ListaDeAdvisorsAdminResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAdvisorsAdminControllerListarUrl = () => {




  return `/v1/admin/advisors`
}

/**
 * @summary Lista advisors com saldo, capacidade, dias e próximo dia disponível
 */
export const advisorsAdminControllerListar = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeAdvisorsAdminResponse> => {

  return httpClient<ListaDeAdvisorsAdminResponse>(getAdvisorsAdminControllerListarUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdvisorsAdminControllerListarQueryKey = () => {
    return [
    `/v1/admin/advisors`
    ] as const;
    }


export const getAdvisorsAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdvisorsAdminControllerListarQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof advisorsAdminControllerListar>>> = ({ signal }) => advisorsAdminControllerListar({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdvisorsAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof advisorsAdminControllerListar>>>
export type AdvisorsAdminControllerListarQueryError = unknown


export function useAdvisorsAdminControllerListar<TData = Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof advisorsAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof advisorsAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdvisorsAdminControllerListar<TData = Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof advisorsAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof advisorsAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdvisorsAdminControllerListar<TData = Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista advisors com saldo, capacidade, dias e próximo dia disponível
 */

export function useAdvisorsAdminControllerListar<TData = Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof advisorsAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdvisorsAdminControllerListarQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdvisorsAdminControllerConfigurarUrl = (id: string,) => {




  return `/v1/admin/advisors/${id}/configuracao`
}

/**
 * @summary Define dias disponíveis e capacidade semanal — aplica no saldo atual imediatamente
 */
export const advisorsAdminControllerConfigurar = async (id: string,
    configurarAdvisorDto: ConfigurarAdvisorDto, options?: Parameters<typeof httpClient>[1]): Promise<AdvisorConfiguracaoResponse> => {

  return httpClient<AdvisorConfiguracaoResponse>(getAdvisorsAdminControllerConfigurarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(configurarAdvisorDto)
  }
);}





export const getAdvisorsAdminControllerConfigurarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advisorsAdminControllerConfigurar>>, TError,{id: string;data: ConfigurarAdvisorDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof advisorsAdminControllerConfigurar>>, TError,{id: string;data: ConfigurarAdvisorDto}, TContext> => {

const mutationKey = ['advisorsAdminControllerConfigurar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof advisorsAdminControllerConfigurar>>, {id: string;data: ConfigurarAdvisorDto}> = (props) => {
          const {id,data} = props ?? {};

          return  advisorsAdminControllerConfigurar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdvisorsAdminControllerConfigurarMutationResult = NonNullable<Awaited<ReturnType<typeof advisorsAdminControllerConfigurar>>>
    export type AdvisorsAdminControllerConfigurarMutationBody = ConfigurarAdvisorDto
    export type AdvisorsAdminControllerConfigurarMutationError = ErroResponse

    /**
 * @summary Define dias disponíveis e capacidade semanal — aplica no saldo atual imediatamente
 */
export const useAdvisorsAdminControllerConfigurar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advisorsAdminControllerConfigurar>>, TError,{id: string;data: ConfigurarAdvisorDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof advisorsAdminControllerConfigurar>>,
        TError,
        {id: string;data: ConfigurarAdvisorDto},
        TContext
      > => {
      return useMutation(getAdvisorsAdminControllerConfigurarMutationOptions(options), queryClient);
    }
